<ng-template transloco let-translate>
  <div class="auth-container">
    <div class="auth-content">
      <h1>{{ translate(TRANSLOCO_PREFIX + '.title') }}</h1>
      <h3>{{ translate(TRANSLOCO_PREFIX + '.details') }}</h3>
      <form id="login-form" class="login-form" fxLayout="column" fxLayoutAlign="space-around" [formGroup]="loginForm" (ngSubmit)="login()">
        @if (errorMessage) {
          <eg-alert type="error" [message]="errorMessage" fxFlex="100"></eg-alert>
        }

        <div fxFlex="100" fxLayout="column">
          <eg-input
            class="mb-12"
            type="email"
            name="email"
            formControlName="email"
            fieldType="M"
            [placeholder]="translate(TRANSLOCO_PREFIX + '.email')"
            [label]="translate(TRANSLOCO_PREFIX + '.email')"
          >
          </eg-input>

          <eg-input
            class="mb-16"
            type="password"
            name="password"
            formControlName="password"
            fieldType="M"
            [placeholder]="translate(TRANSLOCO_PREFIX + '.password')"
            [label]="translate(TRANSLOCO_PREFIX + '.password')"
          >
            <span class="label-link pointer" egFieldSuffixDirective (click)="resetPasswordModal()">
              {{ translate(TRANSLOCO_PREFIX + '.forgotPassword') }}
            </span>
          </eg-input>

          <div class="btn-container" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="btn-sidebar">
              <span>{{ translate(TRANSLOCO_PREFIX + '.noAccount') }}</span>
              <a class="link--basic" [routerLink]="['/', 'auth', 'sign-up']">
                {{ translate(TRANSLOCO_PREFIX + '.button.signUp') }}
              </a>
            </div>
            <button [disabled]="loadingLogin()" id="login-btn" egButton egButtonSize="large" type="submit">
              {{ translate(TRANSLOCO_PREFIX + '.button.login') }}
            </button>
          </div>
        </div>
      </form>
    </div>

    @if (confirmationModal) {
      <div class="modal modal--fullscreen">
        <div class="eg-modal-body" fxLayout="column">
          <div class="eg-modal-title" fxFlex="100" fxLayout="row" FxLayoutAlign="space-between">
            <h2 class="my-0">{{ translate(TRANSLOCO_PREFIX + '.forgotPassword') }}</h2>
            <img class="close-dialog" src="/assets/icons/close.svg" alt="CLOSE" (click)="toggleConfirmModal()" />
          </div>

          <div class="p-20">
            <h3>
              {{ translate(TRANSLOCO_PREFIX + '.enterResetEmail') }}
            </h3>
            <form
              id="reset-form"
              class="login-form login-form--reset"
              fxLayout="column"
              fxLayoutAlign="space-around"
              [formGroup]="confirmEmailForm"
              (ngSubmit)="onResetPassword()"
            >
              <div fxFlex="100" fxLayout="column">
                <eg-input
                  class="mb-12"
                  type="email"
                  name="email"
                  formControlName="email"
                  fieldType="M"
                  [placeholder]="translate(TRANSLOCO_PREFIX + '.email')"
                  [label]="translate(TRANSLOCO_PREFIX + '.email')"
                >
                </eg-input>
              </div>
            </form>
          </div>

          <div fxFlex="100" fxLayout="row" fxLayoutAlign="end" class="eg-modal-footer">
            <button egButton [disabled]="loading()" (click)="onResetPassword()">
              {{ translate(TRANSLOCO_PREFIX + '.button.sendCode') }}
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</ng-template>
